<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Lịch sử duyệt chỉnh sửa hợp đồng</h1>
      <div class="btn-group float-right">
        <button @click="$router.go(-1)" class="f12 font-medium btn btn-outline-secondary">
          <i class="bx bx-left-arrow-alt"></i> Quay lại
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-lg-6 mb-3">
          <div class="form-detail">
            <b class="text-primary p-2 h6">THÔNG TIN BAN ĐẦU</b>
            <div class="p-2">
              <h1
                v-if="oldData.merchantName || oldData.address || oldData.businessRegistrationNumber"
              >
                Thông tin Merchant
              </h1>
              <div class="form-group form-row" v-if="oldData.merchantName">
                <label for="" class="col-sm-4 col-form-label"
                  >Tên MC<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">{{ oldData.merchantName }}</p>
                </div>
              </div>
              <div class="form-group form-row" v-if="oldData.address">
                <label for="" class="col-sm-4 col-form-label"
                  >Địa chỉ<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">{{ oldData.address }}</p>
                </div>
              </div>
              <div class="form-group form-row" v-if="oldData.businessRegistrationNumber">
                <label for="" class="col-sm-4 col-form-label"
                  >MST/ĐKKD<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">{{ oldData.businessRegistrationNumber }}</p>
                </div>
              </div>
              <h1 class="mt-4" v-if="oldData.passport || oldData.placeOfIssue">
                Thông tin người đại diện
              </h1>
              <div class="form-group form-row" v-if="oldData.passport">
                <label for="" class="col-sm-4 col-form-label"
                  >Số CMND/CCCD/HC<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">{{ oldData.passport }}</p>
                </div>
              </div>
              <div class="form-group form-row" v-if="oldData.placeOfIssue">
                <label for="" class="col-sm-4 col-form-label"
                  >Nơi cấp<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">{{ oldData.placeOfIssue }}</p>
                </div>
              </div>
              <h1
                class="mt-4"
                v-if="oldData.merchantBusinessAreas && oldData.merchantBusinessAreas.length > 0"
              >
                Điểm chấp nhận thanh toán
              </h1>
              <div v-for="(item, index) in oldData.merchantBusinessAreas" :key="index">
                <div class="form-group form-row">
                  <b class="col-sm-12">Điểm chấp nhận {{ index + 1 }}</b>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Tên điểm<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">{{ item.areaName }}</p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Địa chỉ<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">{{ item.areaAddress }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 mb-3">
          <div class="form-detail">
            <b class="text-primary p-2 h6">THÔNG TIN CHỈNH SỬA</b>
            <div class="p-2">
              <h1
                v-if="newData.merchantName || newData.address || newData.businessRegistrationNumber"
              >
                Thông tin Merchant
              </h1>
              <div class="form-group form-row" v-if="newData.merchantName">
                <label for="" class="col-sm-4 col-form-label"
                  >Tên MC<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">{{ newData.merchantName }}</p>
                </div>
              </div>
              <div class="form-group form-row" v-if="newData.address">
                <label for="" class="col-sm-4 col-form-label"
                  >Địa chỉ<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">{{ newData.address }}</p>
                </div>
              </div>
              <div class="form-group form-row" v-if="newData.businessRegistrationNumber">
                <label for="" class="col-sm-4 col-form-label"
                  >MST/ĐKKD<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">{{ newData.businessRegistrationNumber }}</p>
                </div>
              </div>
              <h1 class="mt-4" v-if="newData.passport || newData.placeOfIssue">
                Thông tin người đại diện
              </h1>
              <div class="form-group form-row" v-if="newData.passport">
                <label for="" class="col-sm-4 col-form-label"
                  >Số CMND/CCCD/HC<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">{{ newData.passport }}</p>
                </div>
              </div>
              <div class="form-group form-row" v-if="newData.placeOfIssue">
                <label for="" class="col-sm-4 col-form-label"
                  >Nơi cấp<span class="float-right">:</span></label
                >
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">{{ newData.placeOfIssue }}</p>
                </div>
              </div>
              <h1
                class="mt-4"
                v-if="newData.merchantBusinessAreas && newData.merchantBusinessAreas.length > 0"
              >
                Điểm chấp nhận thanh toán
              </h1>
              <div v-for="(item, index) in newData.merchantBusinessAreas" :key="index">
                <div class="form-group form-row">
                  <b class="col-sm-12">Điểm chấp nhận {{ index + 1 }}</b>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Tên điểm<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">{{ item.areaName }}</p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Địa chỉ<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">{{ item.areaAddress }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row px-4">
      <div class="col-lg-6">
        <div class="img-list-wrapper">
          <h1 class="form-inner-heading">Ảnh giấy phép đăng ký kinh doanh</h1>
          <div class="form-group row img-list mr-0 ml-0">
            <ul v-viewer>
              <li v-for="(itemImg, index) in detail.businessScanUrl" :key="index">
                <a href="#popup-slider" data-toggle="modal">
                  <img :src="itemImg" alt="" />
                </a>
              </li>
              <li v-if="detail.businessScanUrl && detail.businessScanUrl.length == 0">
                <div class="add-img">
                  <span class="font-size-12">Không có ảnh</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="img-list-wrapper">
          <h1 class="form-inner-heading">Ảnh cửa hàng</h1>
          <div
            class="form-group row img-list mr-0 ml-0"
            v-for="(item, indexx) in detail.merchantBusinessAreas"
            :key="indexx"
          >
            <h1 class="form-inner-heading">
              Ảnh cửa hàng: {{ item.areaAddress }}
              <span v-show="item.areaDistrict"> - {{ item.areaDistrict }}</span>
              <span v-show="item.areaCity"> - {{ item.areaCity }}</span>
            </h1>
            <ul v-viewer>
              <li v-for="(itemImg, index) in item.areaUrl" :key="index">
                <a href="#popup-slider" data-toggle="modal">
                  <img :src="itemImg" alt="" />
                </a>
              </li>
              <li v-if="item.areaUrl && item.areaUrl.length == 0">
                <div class="add-img">
                  <span class="font-size-12">Không có ảnh</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="row px-4">
      <div class="col-lg-6">
        <div class="img-list-wrapper">
          <h1 class="form-inner-heading">Ảnh CMND/HC</h1>
          <div class="form-group row img-list mr-0 ml-0">
            <ul v-viewer>
              <li v-for="(itemImg, index) in detail.passportScanUrl" :key="index">
                <a href="#popup-slider" data-toggle="modal">
                  <img :src="itemImg" alt="" />
                </a>
              </li>
              <li v-if="detail.passportScanUrl && detail.passportScanUrl.length == 0">
                <div class="add-img">
                  <span class="font-size-12">Không có ảnh</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { SalesManagerService } from '@/services/sales-manager.service'

  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        reqId: this.$route.params.reqId,
        newData: {},
        oldData: {},
        detail: {},

        options: {
          defaultWidth: '100%',
          defaultHeight: '100%',
        },
      }
    },
    components: {},
    async mounted() {
      await this.fetchData()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      async fetchData() {
        try {
          const data = await SalesManagerService.detailHistoryUpdateCus({
            updateCusReqId: this.reqId,
          })
          if (data.success) {
            this.oldData = data.data.oldData
            this.newData = data.data.newData
            this.detail = data.data
          }
        } catch (error) {
          console.log(error)
        }
      },
    },
  }
</script>
